import { MantineProvider, localStorageColorSchemeManager } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import type { PropsWithChildren } from 'react';
import { appTheme } from './mantineTheme';

const colorSchemeManager = localStorageColorSchemeManager({
  key: 'theme',
});

const AppThemeProvider = ({ children }: PropsWithChildren) => {
  return (
    <MantineProvider
      defaultColorScheme="dark"
      colorSchemeManager={colorSchemeManager}
      theme={appTheme}
    >
      <Notifications autoClose={2500} position="top-right" />
      {children}
    </MantineProvider>
  );
};

export default AppThemeProvider;
